<template>
    <div class="logo">
        <router-link tag="img" :src="logo" :to="{name:'HomePage'}"/>
    </div>
</template>

<script>
    import logo from '@/assets/logo.png';

    export default {
        name: "layout-logo",

        data(){
            return {
                logo:logo
            }
        }
    }
</script>

<style scoped lang="less">
    .logo{
        position: relative;
        float: left;
        width: 230px;
        height: 100%;
        img{
            width: 70%;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/elements/LayoutLogo.vue